/*
 * @Date: 2022-10-25 15:30:19
 * @LastEditTime: 2022-10-26 17:29:54
 * @Description:
 */
import { net_common } from "@/api/http";

// ログインセキュリティ画面表示
export const API_DisplayLoginSecurity = (...params) =>
  net_common.post("/api/STDSDC05C07/DisplayLoginSecurity", ...params);

// ログインセキュリティ登録
export const API_LoginSecurityChange = (...params) =>
  net_common.post("/api/STDSDC05C07/LoginSecurityChange", ...params);
